import { apiWithBody, apiWithQuery, ModuleFE_BaseApi, ModuleFE_Thunderstorm, ModuleFE_XHR, StorageKey, ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { HeaderKey_ContentType } from '@nu-art/thunderstorm-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_DiseaseProfile, ApiDef_DiseaseProfileHtml, DBDef_DiseaseProfile, DiseaseProfileEditorPermissionKeys, DiseaseProfilePermissionKeys } from '@app/dp-shared';
import { __stringify, MimeType_html, MimeType_json } from '@nu-art/ts-common';
import { VariableWrapper } from '@app/hcs-frontend';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
export const dispatch_onDiseaseProfilesShowErrorAlertsUpdated = new ThunderDispatcher('__onDiseaseProfilesShowErrorAlertsUpdated');
export const dispatch_onDiseaseProfileChanged = new ThunderDispatcherV3('__onDiseaseProfileUpdated');
export class ModuleFE_DiseaseProfile_Class extends ModuleFE_BaseApi {
    permissions;
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.label }))
        }]);
    __searchFilterMapper = (item) => [item.label, item.initials];
    _v1;
    showDiseaseProfileErrorAlerts = new StorageKey('show-error-alerts');
    constructor() {
        super(DBDef_DiseaseProfile, dispatch_onDiseaseProfileChanged);
        this._v1 = {
            export: apiWithQuery(ApiDef_DiseaseProfile._v1.export, this.onDiseaseProfileExport),
            import: apiWithBody(ApiDef_DiseaseProfile._v1.import),
            deleteChiefComplaint: apiWithBody(ApiDef_DiseaseProfile._v1.deleteChiefComplaint),
            deleteWholeDiseaseProfile: apiWithBody(ApiDef_DiseaseProfile._v1.deleteWholeDiseaseProfile),
            deleteReference: apiWithBody(ApiDef_DiseaseProfile._v1.deleteReference, ModuleFE_Thunderstorm.performGenericUpdate),
        };
        // Declare permission keys
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(DiseaseProfileEditorPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(DiseaseProfilePermissionKeys)
        };
    }
    onDiseaseProfileExport = async (response) => {
        ModuleFE_Thunderstorm.downloadFile({
            fileName: `DP_${response.dpExport.variableName}.json`,
            content: __stringify(response.dpExport, true),
            mimeType: MimeType_json
        });
    };
    // ---- HTML attach/replace/remove for a saved disease profile (edit mode) ----
    // Attach or replace the DP HTML. The file travels as the raw text/html body (like the CSV import),
    // so this uses ModuleFE_XHR rather than apiWithBody. Reseeds the cache with the updated DP so the
    // Review link + HTML overlay re-derive from the new diseaseProfileHtmlUrl. Mirrors setPathwayHtml.
    setDiseaseProfileHtml = async (diseaseProfileId, file) => {
        const { diseaseProfile } = await ModuleFE_XHR.createRequest(ApiDef_DiseaseProfileHtml._v1.setDiseaseProfileHtml)
            .setUrlParams({ diseaseProfileId })
            .setTimeout(ApiDef_DiseaseProfileHtml._v1.setDiseaseProfileHtml.timeout)
            .setHeader(HeaderKey_ContentType, MimeType_html)
            .setBody(file, false)
            .executeSync();
        await this.onEntriesUpdated([diseaseProfile]);
    };
    removeDiseaseProfileHtml = async (diseaseProfileId) => {
        const { diseaseProfile } = await ModuleFE_XHR.createRequest(ApiDef_DiseaseProfileHtml._v1.removeDiseaseProfileHtml)
            .setTimeout(ApiDef_DiseaseProfileHtml._v1.removeDiseaseProfileHtml.timeout)
            .setBodyAsJson({ diseaseProfileId })
            .executeSync();
        await this.onEntriesUpdated([diseaseProfile]);
    };
}
export const ModuleFE_DiseaseProfile = new ModuleFE_DiseaseProfile_Class();
export const convertDbDiseaseProfileToUiDiseaseProfile = (dbDiseaseProfile, variableCollection) => {
    const variable = variableCollection.find((item) => item._id === dbDiseaseProfile.variableId);
    return {
        ...dbDiseaseProfile,
        tags: VariableWrapper.dbTagsToUI(dbDiseaseProfile.tagIds),
        variable,
    };
};
//# sourceMappingURL=ModuleFE_DiseaseProfile.js.map